import { render, staticRenderFns } from "./buscador-persona.vue?vue&type=template&id=e88d91d0&scoped=true&"
import script from "./buscador-persona.component.ts?vue&type=script&lang=ts&"
export * from "./buscador-persona.component.ts?vue&type=script&lang=ts&"
import style0 from "./buscador-persona.vue?vue&type=style&index=0&id=e88d91d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88d91d0",
  null
  
)

export default component.exports